/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessPartnerEligibilityResponse } from '../models/SuccessPartnerEligibilityResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PartnerEligibilityControllerService {

    /**
     * Runs an eligibility check for the given user
     * @returns SuccessPartnerEligibilityResponse OK
     * @throws ApiError
     */
    public static checkPreSignUpEligibility(): CancelablePromise<SuccessPartnerEligibilityResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/partners/eligibility/pre-check',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `The requested entity was not found, or the client has no permission to access the entity.`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
